import { useNoContextualPricing } from '@openx/components-targeting/Targeting/ContextualSegments/utils/contextualPricing';
import type { ContextualPricingApi } from '@openx/types/targeting/contextualPricing';
import type { UseGetContextualPricing } from '@openx/types/targeting/targetingHookTypes';
import { useMemo } from 'react';
import { useDealContext } from '../utils/context/DealContext';

export type ContextualPricingState = {
  pricing: ContextualPricingApi | null;
  isLoading: boolean;
  isFailed: boolean;
};

export const NO_CONTEXTUAL_PRICING: ContextualPricingState = { pricing: null, isLoading: false, isFailed: false };

/** Contextual fees of the given segments from the app's `useGetContextualPricing`, none in apps without it. */
export const useContextualPricingState = (args: Parameters<UseGetContextualPricing>[0]): ContextualPricingState => {
  const { useGetContextualPricing = useNoContextualPricing } = useDealContext();
  const { data, loading, error } = useGetContextualPricing(args);

  return useMemo(() => ({ pricing: data, isLoading: loading, isFailed: !!error }), [data, loading, error]);
};
